import React, { useState } from 'react';
import { AmostraCounter } from '@components/UI/AmostraCounter/Index';
import AmostrasModal from '@components/Modals/Admin/AmostrasModal/Index';

export const AmostrasHandler = ({ row, existingAmostra, nomeItemProcesso }) => {
  const idSolicitacaoProcessoItem = row.id;
  const [visible, setVisible] = useState(false);
  
  const openModal = () => setVisible(true);
  const closeModal = () => setVisible(false);

  return (
    <>
      <div className="d-flex justify-content-center align-items-center gap-2">
        {existingAmostra ? (
          <i
            className="fa-solid fa-square-plus fs-6"
            onClick={openModal}
            style={{ color: '#2b97be', cursor: 'pointer' }}
            title="Amostra já cadastrada — clique para editar"
          />
        ) : (
          <i
            className="fa-solid fa-square-plus fs-6"
            onClick={openModal}
            style={{ color: '#2b97be', cursor: 'pointer' }}
            title="Cadastrar nova amostra"
          />
        )}
        <AmostraCounter idSolicitacaoProcessoItem={idSolicitacaoProcessoItem} />
      </div>

      <AmostrasModal
        visible={visible}
        idSolicitacaoProcessoItem={idSolicitacaoProcessoItem}
        nomeItemProcesso={nomeItemProcesso}
        closeModal={closeModal}
      />
    </>
  );
};

export default AmostrasHandler;